var map = {
	"./bars.svg": "5f00",
	"./checked.svg": "0226",
	"./draggable-bars.svg": "5944",
	"./empty-plan-grid.svg": "4008",
	"./icon-bread.svg": "3179",
	"./icon-camera.svg": "7545",
	"./icon-chef-hat.svg": "c447",
	"./icon-circle-checked.svg": "33a8",
	"./icon-circle.svg": "02bd",
	"./icon-clipboard-color.svg": "2a5c",
	"./icon-clipboard-white.svg": "d968",
	"./icon-clipboard.svg": "a2cf",
	"./icon-egg.svg": "16f7",
	"./icon-error.svg": "70eb",
	"./icon-evening-color.svg": "461f",
	"./icon-evening.svg": "d488",
	"./icon-fruit.svg": "6c93",
	"./icon-grocery-basket.svg": "48b8",
	"./icon-heart-o.svg": "725d",
	"./icon-heart.svg": "d2a2",
	"./icon-midday-color.svg": "7750",
	"./icon-midday.svg": "d507",
	"./icon-morning-color.svg": "c018",
	"./icon-morning.svg": "207a",
	"./icon-pancakes.svg": "d82a",
	"./icon-pie-chart.svg": "7267",
	"./icon-plate.svg": "893a",
	"./icon-plus.svg": "77ea",
	"./icon-recipes.svg": "934d",
	"./icon-rice.svg": "efd8",
	"./icon-seafood.svg": "965e",
	"./icon-settings.svg": "d86c",
	"./icon-tuna-can.svg": "b268",
	"./icon-veggies.svg": "6a3a",
	"./icon-warning-shield.svg": "b9fb",
	"./left-arrow.svg": "947f",
	"./minus.svg": "de59",
	"./shopping.svg": "7b44",
	"./square_checked.svg": "c6c3",
	"./square_minus.svg": "10ae",
	"./square_unchecked.svg": "99bc",
	"./times.svg": "1572",
	"./tupperware-solo.svg": "a92c",
	"./unchecked.svg": "4c6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";